import React from 'react';
import { Paper, PaperProps } from '@mui/material';
import VerticalOverflowScroller from './VerticalOverflowScroller';

export const dropdownScrollerSx = {
  height: 'auto',
  '&::-webkit-scrollbar': { width: 7 },
  '&::-webkit-scrollbar-track': { bgcolor: 'rgba(255,255,255,0.04)' },
  '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(255,255,255,0.24)', borderRadius: 999 },
} as const;

/** Keep the menu border clear while fading only the overflowing options. */
const DropdownScrollPaper = React.forwardRef<HTMLDivElement, PaperProps>(function DropdownScrollPaper(
  { children, sx, ...props }, ref,
) {
  return (
    <Paper
      {...props}
      ref={ref}
      sx={[
        { position: 'absolute', outline: 0 },
        ...(Array.isArray(sx) ? sx : [sx]),
        { display: 'flex', flexDirection: 'column', overflow: 'hidden' },
      ]}
    >
      <VerticalOverflowScroller
        fadeHeight={28}
        sx={{ display: 'flex', flexDirection: 'column' }}
        scrollerSx={dropdownScrollerSx}
      >
        {children}
      </VerticalOverflowScroller>
    </Paper>
  );
});

export default DropdownScrollPaper;
